import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box, Button, Center, Divider, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import SearchInput from "@/components/atoms/SearchInput";
import HeaderAddressButton from "@/components/molecules/HeaderAddressButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import { useAppNavigation } from "@/hooks/application/navigation";
import { RootNavigation } from "@/navigation/Root";
import { formatToCurrency, formatWeight } from "@/utils/helpers";

import CartItemList from "./components/CartItemList";
import { CartScreenProps } from "./types";

const CartMobile = ({
  items,
  shipmentValue,
  store,
  subtotal,
  onPressClear,
  onPressContinue,
  onPressNotFoundItem,
}: CartScreenProps) => {
  const { goBack, navigateBetweenStacks } = useAppNavigation<RootNavigation>();
  const total = subtotal + shipmentValue;
  const totalWeight = items?.reduce((acc, item) => acc + item.item?.peso * item.quantidade, 0);

  return (
    <Container Header={<MobileHeader title="Carrinho" onBackPress={() => goBack()} />}>
      <HStack justifyContent="space-between" alignItems="center">
        <HStack alignItems="center">
          <Box px="3" bgColor="primary.600" rounded="md" mr="2">
            <Text color="white.50" fontSize="lg" bold>
              {items?.length}
            </Text>
          </Box>
          <Text fontSize="lg">itens</Text>
        </HStack>
        <VStack>
          <Text fontSize="lg" textAlign="right">
            Valor total
          </Text>
          <HStack space="2" alignItems="center">
            <Text fontSize="lg">{formatWeight(totalWeight)}</Text>
            <Text color="primary.600" fontSize="xl" bold>
              {formatToCurrency(total)}
            </Text>
          </HStack>
        </VStack>
      </HStack>
      <Box w="full" bgColor="white.50" shadow="4" my="4" p="2" rounded="md">
        <HeaderAddressButton w="full" showCompletion />
      </Box>
      {items.length ? (
        <>
          <Box my="2">
            <Text fontSize="xl" bold color="text.600">
              {store?.nome_fantasia}
            </Text>
          </Box>
          <HStack my="2" justifyContent="space-between" alignItems="center">
            <Box p="1" px="2" borderWidth="2" borderColor="gray.400" rounded="md">
              <Text color="text.400" bold>
                Frete{" "}
                {shipmentValue === 0
                  ? "grátis"
                  : !shipmentValue
                  ? "indisponível"
                  : formatToCurrency(shipmentValue)}
              </Text>
            </Box>
            <Box p="1" px="2" borderWidth="2" borderColor="gray.400" rounded="md">
              <Text color="text.400" bold>
                Subtotal {formatToCurrency(subtotal)}
              </Text>
            </Box>
          </HStack>
          <Box py="2">
            <FormButton onPress={onPressContinue}>Comprar</FormButton>
          </Box>
          <Box my="4">
            <Text fontSize="lg" bold color="text.600">
              Lista de produtos
            </Text>
            <Divider my="2" />
          </Box>
          <VStack pb="4">
            <CartItemList items={items} />
          </VStack>
          <Box py="2" mb="24">
            <FormButton onPress={onPressContinue}>Comprar</FormButton>
            <FormButton
              variant="solid"
              colorScheme="white"
              my="4"
              shadow="6"
              textColor="primary.600"
              onPress={onPressNotFoundItem}>
              Não achou um produto? Clique aqui
            </FormButton>
            <Center>
              <Button
                variant="ghost"
                leftIcon={
                  <Icon
                    as={<MaterialCommunityIcons name="trash-can-outline" />}
                    color="primary.600"
                  />
                }
                onPress={onPressClear}>
                Esvaziar carrinho
              </Button>
            </Center>
          </Box>
        </>
      ) : (
        <VStack mt="8" justifyContent="center" alignItems="center" space="4">
          <Text fontSize="lg" bold>
            Seu carrinho de compras está vazio
          </Text>
          <Text>Aproveite para buscar alguns produtos</Text>
          <Pressable
            w="100%"
            pointerEvents="box-only"
            onPress={() => navigateBetweenStacks("search")}>
            <SearchInput h="42px" mt="4" fontSize="lg" editable={false} />
          </Pressable>
        </VStack>
      )}
    </Container>
  );
};

export default CartMobile;
